import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import ChangePasswordModal from './ChangePasswordModal';

const Login = () => {
	const [username, setUsername] = useState('');
	const [password, setPassword] = useState('');
	const [error, setError] = useState('');
	const [loading, setLoading] = useState(false);
	const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
	const { login, loadUser } = useAuth();
	const navigate = useNavigate();

	const handleSubmit = async (e) => {
		e.preventDefault();
		setError('');
		setLoading(true);

		try {
			const result = await login(username, password);

			if (result.success) {
				// Verificar si requiere cambio de contraseña
				if (result.requiere_cambio_password) {
					setShowChangePasswordModal(true);
				} else if (result.role === 'cliente') {
					navigate('/admin/dgii');
				} else {
					navigate('/admin/dashboard');
				}
			} else {
				// Mostrar mensaje de error más específico
				const errorMessage = result.error || 'Error al iniciar sesión';
				setError(errorMessage);
				console.error('Error de login:', result);
			}
		} catch (err) {
			console.error('Error inesperado:', err);
			setError('Error de conexión. Verifica que el servidor esté corriendo.');
		}

		setLoading(false);
	};

	const handlePasswordChangeSuccess = async () => {
		// Recargar información del usuario para actualizar el estado
		const updatedUser = await loadUser();
		setShowChangePasswordModal(false);
		const role = updatedUser?.profile?.role;
		navigate(role === 'cliente' ? '/admin/dgii' : '/admin/dashboard');
	};

	return (
		<div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary/5 via-white to-secondary/5 py-12 px-4 sm:px-6 lg:px-8">
			<div className="max-w-md w-full space-y-8 bg-white p-8 rounded-2xl shadow-xl">
				<div>
					<h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
						Iniciar Sesión
					</h2>
					<p className="mt-2 text-center text-sm text-gray-600">
						Accede al panel de administración
					</p>
				</div>
				<form className="mt-8 space-y-6" onSubmit={handleSubmit}>
					{error && (
						<div className="rounded-md bg-red-50 p-4">
							<div className="flex">
								<div className="ml-3">
									<h3 className="text-sm font-medium text-red-800">{error}</h3>
								</div>
							</div>
						</div>
					)}
					<div className="rounded-md shadow-sm -space-y-px">
						<div>
							<label htmlFor="username" className="sr-only">
								Usuario
							</label>
							<input
								id="username"
								name="username"
								type="text"
								required
								className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-primary focus:border-primary focus:z-10 sm:text-sm"
								placeholder="Nombre de usuario"
								value={username}
								onChange={(e) => setUsername(e.target.value)}
							/>
						</div>
						<div>
							<label htmlFor="password" className="sr-only">
								Contraseña
							</label>
							<input
								id="password"
								name="password"
								type="password"
								required
								className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-primary focus:border-primary focus:z-10 sm:text-sm"
								placeholder="Contraseña"
								value={password}
								onChange={(e) => setPassword(e.target.value)}
							/>
						</div>
					</div>

					<div>
						<button
							type="submit"
							disabled={loading}
							className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-primary hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
						>
							{loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
						</button>
					</div>
				</form>
			</div>

			{/* Modal para cambio de contraseña */}
			<ChangePasswordModal
				isOpen={showChangePasswordModal}
				onClose={() => setShowChangePasswordModal(false)}
				onSuccess={handlePasswordChangeSuccess}
			/>
		</div>
	);
};

export default Login;

